export default __webpack_public_path__ + "static/media/error.7f9ba1dd.svg";